import {SODeleteOrganization} from '../../core/organization/so-delete-organization';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteOrganization extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteOrganization;
}